import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'

$(document).ready(function(){
  let navLeft = $('.pro-nav .nav li.active').offset().left - 30
  $('.pro-nav .nav').scrollLeft(navLeft)
})